export var timeDown = function timeDown(time) {
    var minutes = 0, seconds = 0;
    if (time >= 0) {
        minutes = Math.floor(time / 60);
        seconds = Math.floor(time % 60);
    } else {
        time = 0;
    }
    minutes = minutes + '分';
    seconds = seconds < 10 ? '0' + seconds + '秒' : seconds + '秒';
    var str = minutes + seconds;
    return str;
};
export var formatDate = function formatDate(time) {
    time = new Date(parseInt(time * 1000));
    var hours = time.getHours();
    var second = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
    return ''.concat(hours, ':').concat(second);
};
export var formatTimeDate = function formatTimeDate() {
    var time = new Date();
    var year = time.getFullYear();
    var mon = time.getMonth() + 1;
    var day = time.getDate();
    return ''.concat(year).concat(mon).concat(day);
};
export var formatHour = function formatHour(time) {
    time = new Date(parseInt(time * 1000));
    var hours = time.getHours();
    var minutes = time.getMinutes();
    return hours + '点' + minutes + '分钟';
};
export var changeParams = function changeParams(param) {
    return JSON.stringify(param).replace(/:/g, '=').replace(/,/g, '&').replace(/{/g, '').replace(/}/g, '').replace(/"/g, '');
};
export var hasClass = function hasClass(el, cls) {
    if (!el || !cls) {
        return false;
    }
    if (cls.indexOf(' ') !== -1) {
        throw new Error('className should not contain space.');
    }
    if (el.classList) {
        return el.classList.contains(cls);
    } else {
        return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }
};
export var removeClass = function removeClass(el, cls) {
    if (!el || !cls) {
        return false;
    }
    var classes = cls.split(' ');
    var curClass = ' ' + el.className + ' ';
    for (var i = 0; i < classes.length; i++) {
        var clsName = classes[i];
        if (!clsName) {
            continue;
        }
        if (el.classList) {
            el.classList.remove(clsName);
        } else {
            if (hasClass(el, clsName)) {
                curClass = curClass.replace(' ' + clsName + ' ', ' ');
            }
        }
    }
    if (!el.classList) {
        el.className = trim(curClass);
    }
};
export var addClass = function addClass(el, cls) {
    if (!el) {
        return false;
    }
    var curClass = el.className;
    var classes = (cls || '').split(' ');
    for (var i = 0; i < classes.length; i++) {
        var clsName = classes[i];
        if (!clsName) {
            continue;
        }
        if (el.classList) {
            el.classList.add(clsName);
        } else {
            if (!hasClass(el, clsName)) {
                curClass += ' ' + clsName;
            }
        }
    }
    if (!el.classList) {
        el.className = curClass;
    }
};
export var getCookie = function getCookie(name) {
    var arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if (arr = document.cookie.match(reg)) {
        return unescape(arr[2]);
    } else {
        return null;
    }
};
export var guid = function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 3 | 8;
        return v.toString(16);
    });
};
export var isArray = function isArray(obj) {
    if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object array]') {
        return true;
    }
    return false;
};
export var getRandom = function getRandom(num) {
    var random = Math.floor((Math.random() + Math.floor(Math.random() * 9 + 1)) * Math.pow(10, num - 1));
    return random;
};
export var isTestEvir = function isTestEvir() {
    var hostname = window.location.hostname;
    console.log(hostname);
    return hostname.indexOf('.test') > -1;
};
export var jsBridgeForSSAI = function jsBridgeForSSAI(action, params, callback) {
    var unCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    try {
        var ua = navigator.userAgent;
        var data = {
            action: action,
            params: params || {},
            callback: callback || '',
            unCallback: unCallback
        };
        data = JSON.stringify(data);
        if (/SSAI_Android$/.test(ua)) {
            window.ssaiAppJS.postMessage(data);
        } else {
            window.webkit.messageHandlers.ssaiAppJS.postMessage(data);
        }
    } catch (error) {
        clearDataGovernanceTimer();
        console.warn(error, '松鼠手机APP协议访问异常\uFF01');
    }
};
function clearDataGovernanceTimer() {
    console.warn('学习版本不支持数据治理协议\uFF01');
    window.dataGovernanceTimer && clearInterval(window.dataGovernanceTimer);
}
export var isSSAI = function isSSAI() {
    return /SSAI_Android|SSAI_iOS$/.test(navigator.userAgent);
};
export var destroyDraftToolsBar = function destroyDraftToolsBar() {
    var param = {
        action: 'destroyDraft',
        params: {},
        callback: ''
    };
    window.ssaiAppJS && window.ssaiAppJS.postMessage(JSON.stringify(param));
};